import { render, staticRenderFns } from "./rule_item.vue?vue&type=template&id=22b22df5&"
import script from "./rule_item.vue?vue&type=script&lang=js&"
export * from "./rule_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports